<template>
  <div>
    <Dialog
        :dismissableMask="true"
        :style="{ width: '35vw' }"
        :modal="true"
        :visible.sync="show"
        @hide="closeDialog"
        :contentStyle="{overflow: 'visible'}"
    >
      <template #header>
        <i style=" transform: scale(1.7); " class="pi pi-th-large"></i>
        <h1>הוספת נושא משמעת</h1>
      </template>

      <div class="p-pt-4 p-fluid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="firstname6">שם מזהה</label>

          <InputText type="text" v-model="newItem.id" autofocus/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="lastname6">שם</label>
          <InputText id="lastname6" type="text" v-model="newItem.hebrewName" />
        </div>

<!--        role -->
        <div class="p-field p-col-12 p-md-3">
          <label>הרשאה</label>

          <Dropdown v-model="newItem.role" :options="roles">
            <template #option="slotProps">
              <span>{{ getRoleLabel(slotProps.option) }}</span>
            </template>
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span>{{ getRoleLabel(newItem.role) }}</span>
              </div>
              <span v-else> בחר הרשאה </span>
            </template>
          </Dropdown>
        </div>

        <!-- type -->

        <div class="p-field p-col-12 p-md-3">
          <label>סוג</label>

          <Dropdown v-model="newItem.type" :options="types">
            <template #option="slotProps">
              <span class="subject-tracking" :class="slotProps.option">{{ getTypeLabel(slotProps.option) }}</span>
            </template>
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span class="subject-tracking" :class="newItem.type">{{ getTypeLabel(newItem.type) }}</span>
              </div>
              <span v-else> בחר סוג </span>
            </template>
          </Dropdown>
        </div>

      </div>


      <template #footer>
        <Button
            label="ביטול"
            icon="pi pi-times"
            @click="closeDialog"
            class="p-button-secondary"
        />
        <Button class="p-button-success" label="הוספה" icon="pi pi-check" @click="post"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Service from "../service/Service";

export default {
  service: null,
  props: {
    show: Boolean,
  },
  created() {
    this.service = new Service();
  },
  mounted() {
    this.setNewItwmFields();
  },
  data() {
    return {
      roles: ["USER", "MIKTZOI", "ADMIN"],
      types: ["t-danger","t-warning","t-success","t-help", "t-info", "t-secondary"],
      newItem: null,
    };
  },

  methods: {
    getRoleLabel(status) {
      switch (status) {
        case "ADMIN":
          return "מנהל";

        case "USER":
          return "מחנך";

        case "MIKTZOI":
          return "מקצועי";

        default:
          return "NA";
      }
    },
    getTypeLabel(type) {
      switch (type) {
        case "t-danger":
          return "סכנה";
        case "t-warning":
          return "אזהרה";
        case "t-success":
          return "הצלחה";
        case "t-help":
          return "רפואה";
        case "t-info":
          return "מידע";
        case "t-secondary":
          return "שונות";
        default:
          return "שגיאה";
      }
    },
    setNewItwmFields() {
      this.newItem = {
        id: null,
        hebrewName: null,
      };
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {
      let validate = true;
      for (const key in this.newItem) {
        if (this.newItem[key] === null) {
          validate = false;
        }
      }

      if (validate === true) {
        await this.service
          .post(this.newItem, 'subject-tracing')
          .then((data) => {
            this.$emit("addItem", this.newItem);
            this.setNewItwmFields();
            this.openNotification(
              "success",
              `מעולה`,
              `הכיתה התתוספה במערכת`
            );

            this.closeDialog();
          })
          .catch(() => {
            this.openNotification(
              "danger",
              `אופס`,
              `אולי קיים כבר משתמש עם ת.ז. זהה`
            );
          });
      } else {
        this.openNotification(
          "danger",
          `אופס`,
          `חלק מהשדות חסרים או שגויים`
        );
      }
    },
    openNotification(color, title, text, position = "right-left", duration = 3000) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>

<style >
</style>